/**
 * First-login onboarding gate helpers (localStorage only).
 * Used by router/index.js — not by the main chatbot.
 */
import { getStoredAssetType } from '@/helpers/expenseCreateRoute';

/** Same key set on login from userData.data.isOnboardingCompleted */
export function isOnboardingIncomplete() {
  return localStorage.getItem('IsOnboardingCompleted') === 'false';
}

/** @deprecated use isOnboardingIncomplete — kept for existing imports */
export function shouldForceOnboardingChoice() {
  return isOnboardingIncomplete();
}

export function markOnboardingCompleted() {
  localStorage.setItem('IsOnboardingCompleted', 'true');
}

export const ONBOARDING_CHOICE_PATH = '/onboarding';
export const ONBOARDING_CHAT_PATH = '/onboarding/chat';
export const ONBOARDING_WIZARD_PATH = '/onboarding/wizard';

/** Company Admin user type (localStorage.userType). */
export const COMPANY_ADMIN_USER_TYPE = 'usertype02';

export function getStoredUserType() {
  try {
    return (
      localStorage.getItem('userType') ||
      localStorage.getItem('UserType') ||
      localStorage.getItem('usertype') ||
      ''
    ).trim();
  } catch (e) {
    return '';
  }
}

/** True when logged-in user is Company Admin (usertype02). */
export function isCompanyAdminUserType(userType = getStoredUserType()) {
  return String(userType || '').trim().toLowerCase() === COMPANY_ADMIN_USER_TYPE;
}

/** Choice screen asset types: Vacation Home and Household. */
export function isOnboardingChoiceAssetType(assetType = getStoredAssetType()) {
  const t = String(assetType || '').trim().toLowerCase();
    return t === 'vacation home' || t === 'household' || t === 'boat' || t === 'aircraft' || t === 'companies & llcs'||t === 'rv'; 
}

/**
 * Portal vs SpliytGenie choice — Company Admin + VH/Household only.
 * Everyone else (other roles / asset types) → portal wizard.
 */
export function canShowOnboardingChoice(
  assetType = getStoredAssetType(),
  userType = getStoredUserType()
) {
  return isOnboardingChoiceAssetType(assetType) && isCompanyAdminUserType(userType);
}

/**
 * Company Admin + Vacation Home / Household → choice screen.
 * Any other user type or asset type → portal wizard directly.
 */
export function getOnboardingEntryPath() {
  return canShowOnboardingChoice() ? ONBOARDING_CHOICE_PATH : ONBOARDING_WIZARD_PATH;
}

export function isAiPortalPath(path = '') {
  return String(path).startsWith(ONBOARDING_CHAT_PATH);
}
